var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queue-tabs-container"},_vm._l((_vm.tabs),function(options,tab){return _c('div',{key:tab,class:{
      'tab': true,
      'tab-active': _vm.currentTab == tab || _vm.isDesktop  
    },on:{"click":function($event){return _vm.onChangeTab(tab)}}},[_c('img',{attrs:{"src":_vm.currentTab == tab || _vm.isDesktop ? ("/icons/tabs/" + tab + "-active.svg") : ("/icons/tabs/" + tab + ".svg")}}),_vm._v("\n    "+_vm._s(_vm.$t(("tabs." + tab)))+"\n    "),_c('span',{style:({
      'color': options.important && _vm.counters[tab] ? '#e2223b' : '#A4A3A1'
    })},[_vm._v("("+_vm._s(_vm.counters[tab] || 0)+")")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }